import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'concatenate',
    standalone: false
})
export class ConcatenatePipe implements PipeTransform {
  transform(value: any[], key: string): string | any[] {
    if (!value || !key) {
      return value;
    }
    return value.map(taetigkeit => taetigkeit[key]).join(', ');
  }
}
